import { useId } from 'react';
import { Box, Typography } from '@mui/material';

import { useAuth } from '../../../core/authContext';
import { feedbackSurveyUrl } from '../../../core/surveyLink';
import { GET_STARTED_URL } from '../../Samples/sampleCopy';
import { PRIMARY_BUTTON_SX, TEXT_BUTTON_SX } from '../../Samples/SampleBanner';
import { DASH } from '../tokens';

export const CONNECT_SIS_TITLE = 'Connect your SIS to see your ML students';
export const CONNECT_SIS_BODY =
  'Flashlight360 is connected, so you can already see benchmarks, assignments, and who’s on Flashlight360. Click Get Started, fill out a short form, and a Flashlight Learning representative will contact you to connect your SIS.';

export function ConnectSisBanner() {
  const titleId = useId();
  const { user } = useAuth();
  return (
    <Box
      component="section"
      role="region"
      aria-label="Connect your SIS"
      aria-describedby={titleId}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '24px',
        padding: '20px 24px',
        borderRadius: '12px',
        bgcolor: DASH.stats.bannerBg,
      }}
    >
      <Box sx={{ flex: '1 1 auto', minWidth: 0, display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <Typography
          id={titleId}
          component="h2"
          sx={{ fontSize: 16, lineHeight: '24px', fontWeight: 700, color: DASH.ink }}
        >
          {CONNECT_SIS_TITLE}
        </Typography>
        <Typography sx={{ maxWidth: 640, fontSize: 16, lineHeight: '24px', fontWeight: 500, color: DASH.muted }}>
          {CONNECT_SIS_BODY}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
        <Box
          component="a"
          href={feedbackSurveyUrl(user?.id)}
          target="_blank"
          rel="noopener noreferrer"
          sx={TEXT_BUTTON_SX}
        >
          Send feedback
        </Box>
        <Box component="a" href={GET_STARTED_URL} target="_blank" rel="noopener noreferrer" sx={PRIMARY_BUTTON_SX}>
          Get Started
        </Box>
      </Box>
    </Box>
  );
}
